/* eslint new-cap:0 */
import _ from 'underscore';
import inlineEditTemplate from '../../template/product-groups-inline-edit-bid.pug';
import { ProductGroupsEditBidBaseView } from '../view/product-group-edit-bid-base';

export class ProductGroupsEditBidBoostView extends ProductGroupsEditBidBaseView {
  initialize({
    view,
    deps,
    BidBoost = _.result(_.first(deps.config.get('CurrentAdGroup').Settings), 'BidBoostValue', 1),
    IsExcluded = false,
    selectedItems = [],
  } = {}) {
    this.deps = deps;
    this.selectedItems = selectedItems;
    const template = inlineEditTemplate;

    super.initialize({
      view,
      deps,
      model: {
        Multiplier: BidBoost.Multiplier,
        IsExcluded,
      },
      bidProperty: 'Multiplier',
      validators: {
        Multiplier: [{
          type: 'type',
          message: this.deps.i18n.getString('ProductGroupsGrid_BidFormat_Validation'),
        }],
      },
      selectedItems,
      template: values => template(_.defaults(values, {
        isBidBoost: true,
        percentSymbol: this.deps.config.get('globalization.number.percentSymbol'),
        bulkEditHeaderText: this.deps.i18n.getString('ProductGroupsGrid_BulkEdit_BidBoost_HeaderText'),
        bulkEditLabel: this.deps.i18n.getString('ProductGroupsGrid_BulkEdit_BidBoost_DescriptionText'),
      })),
    });
  }

  getUpdated() {
    let updated;
    if (this.viewModel.IsExcluded()) {
      updated = { ..._.pick(this.selectedItems[0], 'Id', 'CampaignId', 'AdGroupId'), IsExcluded: true };
    } else {
      updated = {
        ..._.pick(this.selectedItems[0], 'Id', 'CampaignId', 'AdGroupId', this.getFieldName()),
        BidBoost: {
          Multiplier: this.getValue().bidBoost,
        },
      };
    }
    if (!this.viewModel.IsExcluded() && this.selectedItems[0].IsExcluded) {
      updated.IsExcluded = false;
    }
    return updated;
  }

  genEditSchema() {
    const bidBoostEditSchema = this.deps.s$ProductGroup.properties.BidBoost.schema;
    bidBoostEditSchema.properties.IsExcluded = this.deps.s$ProductGroup.properties.IsExcluded;
    return bidBoostEditSchema;
  }

  getFieldName() {
    return ['BidBoost', 'IsExcluded'];
  }

  getValue() {
    return {
      bidBoost: this.viewModel.IsExcluded() ? null : this.viewModel.Multiplier().toString(),
    };
  }
}
